import React, { Fragment } from 'react';

import cx from 'classnames';
import { includes } from 'ramda';

import { ETripEvent } from 'detailsv2/structure';
import i18n from 'i18n';

import { useMoreDetails } from '../../../../TripEventBlock/MoreDetails/functions';
import { EEventType } from '../../types';
import s from './index.module.css';
import { IMoreDetails } from './types';

export const MoreDetailsButton = ({ tripEvent, activeType, detailsConfig }: IMoreDetails) => {
  const { showDetails, setShowDetails } = useMoreDetails();
  const isFlightOrTransferType = includes(tripEvent.type, [ETripEvent.Flight, ETripEvent.Transfer]);

  if (tripEvent.daysRange.start !== tripEvent.day && !isFlightOrTransferType) {
    return null;
  }

  if (activeType === EEventType.Accommodation) {
    return null;
  }

  return (
    <div className={cx(s.container, activeType !== EEventType.All && s.moveContainerToLeft)}>
      {includes(tripEvent.type, [
        ETripEvent.Flight,
        ETripEvent.Transfer,
        ETripEvent.Accommodation,
        ETripEvent.Activity,
      ]) && (
        <div
          className={cx(s.detailsButton, !showDetails && s.activeButton)}
          onClick={(event) => {
            event.stopPropagation();
            setShowDetails(!showDetails);
          }}
        >
          <span className={cx(s.details, { [s.hidden]: !showDetails })} data-block>
            {i18n.t('proposal_content.event_details.more_details')}
          </span>
          <span className={cx(s.details, { [s.hidden]: showDetails })} data-block>
            {i18n.t('proposal_content.event_details.hide_details')}
          </span>
        </div>
      )}
      <div className={cx(s.moreDetails, { [s.hidden]: showDetails })} data-block>
        {detailsConfig(tripEvent.type).map((line, i) => (
          <Fragment key={i}>{line}</Fragment>
        ))}
      </div>
    </div>
  );
};
